import React from 'react'
import { Link } from "react-router-dom"; 
import { Typography, Card, CardContent, CardMedia } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { demoThumbnailUrl, demoVideoUrl, demoVideoTitle, demoChannelUrl, demoChannelTitle } from "../utils/constants";

const VideoCard = ({ video }) => {
  return (
  <Card sx={{ width: { xs: '100%', sm: '358px', md: "310px", }, boxShadow: "none", borderRadius: 0,backgroundColor:'black' }}>
  <Link to={video.id.videoId ? `/video/${video.id.videoId}` : `/video/cV2gBU6hKfY` } >
    <CardMedia image={video.snippet?.thumbnails?.high?.url || demoThumbnailUrl} alt={video.snippet?.title} 
      sx={{ width: { xs: '100vw', sm: '358px',md: "310px"}, height: 180 ,borderRadius: 3}} 
    />
  </Link>
  <CardContent sx={{ backgroundColor: "#000", height: '70px' }}>
    <Link to={video.id.videoId ? `/video/${video.id.videoId}` : demoVideoUrl } >
      <Typography variant={`subtitle1`} fontWeight="bold" color="#FFF">
        {video.snippet?.title.slice(0, 60) || demoVideoTitle.slice(0, 60)}
      </Typography>
    </Link>
    <Link to={video.snippet?.channelId ? `/channel/${video.snippet?.channelId}` : demoChannelUrl} >
      <Typography variant={`subtitle2`} color="gray">
        {video.snippet?.channelTitle || demoChannelTitle}
        <CheckCircleIcon sx={{ fontSize: "12px", color: "gray", ml: "5px" }} />
      </Typography>
    </Link>
  </CardContent>
</Card>
);
}
export default VideoCard